import React from "react";
import { useNavigate } from "react-router-dom";
import { Form,Formik } from "formik";
import * as Yup from "yup";

import { axiosInstance } from "api/axios";
import { RESET_PASS_URL } from "api/Service";
import { pathGenerators } from "utils/routes";

import { AuthLayout } from "../components/AuthLayout/AuthLayout";
import { PasswordInput } from "../components/PasswordInput/PasswordInput";
import s from "./ResetPasswordPage.module.css";

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .max(255)
    .min(6, "Password must be at least 6 characters long")
    .required("Password is required"),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

const initialValues = {
  password: "",
  passwordConfirmation: "",
};

const ResetPasswordPage = () => {
  const params = new URLSearchParams(window.location.search);
  const userCode = params.get("user_code");
  const resetId = params.get("reset_id");

  const navigate = useNavigate();

  const headers = {
    Accept: "*",
    "Content-Type": "application/json",
    authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
  };

  const handleSubmit = async (values) => {
    try {
      const response = await axiosInstance.post(
        RESET_PASS_URL,
        {
          userCode: userCode,
          resetId: resetId,
          password: values.password,
          password2: values.passwordConfirmation,
        },
        { headers: headers }
      );

      if (response.status === 200) {
        navigate(pathGenerators.auth.login());
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AuthLayout>
      <div className={s.container}>
        <div className={s.textContainer}>
          <h1 className={s.title}>Create New Password</h1>
          <p className={s.secondaryText}>Please create your new password</p>
        </div>

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <div className={s.inputsContainer}>
                <div className={s.inputWrapper}>
                  <label className={s.label}>New password</label>
                  <PasswordInput id="password" name="password" />
                  {errors.password && touched.password && (
                    <div className="errorstext">{errors.password}</div>
                  )}
                </div>

                <div className={s.inputWrapper}>
                  <label className={s.label}>Confirm new password</label>
                  <PasswordInput
                    id="passwordConfirmation"
                    name="passwordConfirmation"
                  />
                  {errors.passwordConfirmation &&
                    touched.passwordConfirmation && (
                      <div className="errorstext">
                        {errors.passwordConfirmation}
                      </div>
                    )}
                </div>
              </div>

              <button
                className={s.submitBtn}
                type="submit"
                disabled={isSubmitting}
              >
                Save
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export { ResetPasswordPage };